import { render, staticRenderFns } from "./view-plans.vue?vue&type=template&id=b72f6f86"
import script from "./view-plans.vue?vue&type=script&lang=js"
export * from "./view-plans.vue?vue&type=script&lang=js"
import style0 from "./view-plans.vue?vue&type=style&index=0&id=b72f6f86&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports